import React, { useEffect, useRef } from 'react';
import './Hero.scss';
import logoImg from '../../assets/logo.png';
import { createPopper } from '@popperjs/core';
import { gsap } from 'gsap';
import videoLoopD from '../../assets/hero-desktop.mp4';
import videoLoopM from '../../assets/hero-mobile.mp4';
import posterD from '../../assets/poster-desktop.png';
import posterM from '../../assets/poster-mobile.png';

function Hero() {
  const logoTooltip = useRef();
  const videoLoopRef = useRef();

  useEffect(() => {
    gsap.to('#logo', { opacity: 1, y: 0, duration: 0.7, delay: 0.5 });
    gsap.to('#title', { opacity: 1, y: 0, duration: 0.7, delay: 0.8 });

    videoLoopRef.current.play();
  }, []);

  const handleMouseEnterLogo = (e) => {
    const content = logoTooltip.current;
    createPopper(e.target, content, {
      placement: 'bottom',
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 5]
          }
        }
      ]
    });
    content.style.visibility = 'visible';
  };

  const handleMouseLeaveLogo = () => {
    logoTooltip.current.style.visibility = 'hidden';
  };

  return (
    <section className="hero">
      <div className="video-loop-container">
        <video autoPlay muted playsInline loop className="video-loop" ref={videoLoopRef}>
          <source media="(min-width:481px)" src={videoLoopD} poster={posterD} type="video/mp4" />
          <source media="(max-width:480px)" src={videoLoopM} poster={posterM} type="video/mp4" />
          Your browser does not support HTML5 video.
        </video>
      </div>
      <div className="hero__titleBox">
        <div className="logo__container" id="logo">
          <p className="logo-copy">Content By</p>
          <a
            href="https://www.realtor.com/thats-who-we-r/"
            target="_blank"
            rel="noreferrer"
            className="nar"
          >
            <img
              className="logo"
              src={logoImg}
              alt="NAR logo"
              onMouseEnter={(e) => {
                handleMouseEnterLogo(e);
              }}
              onMouseLeave={handleMouseLeaveLogo}
            />
          </a>
          <div className="tooltip" ref={logoTooltip}>
            <p className="tooltip-content">Visit www.realtor.com/thats-who-we-r/</p>
          </div>
        </div>
        <div className="hero__titleBox-texts" id="title">
          <p className="hero__titleBox-title hero__titleBox-title-desktop">
            Buying a Home in 2022:
          </p>
          <p className="hero__titleBox-title hero__titleBox-title-mobile">
            Buying a Home <br />
            in 2022:
          </p>
          <p className="hero__titleBox-subtitle">
            How to navigate an ultracompetitive real estate market
          </p>
        </div>
      </div>
    </section>
  );
}

export default Hero;
